import { Link, Typography } from "@material-ui/core";
import ContentPage from "../ContentPage";

export default function Returns() {
  return (
    <ContentPage title="Return Policy">
      <Typography variant="caption" color="textSecondary">
        Last updated on June 30th, 2025
      </Typography>

      <p>
        At <strong>Streamily</strong>, we’re passionate about connecting fans
        with their favorite artists through exclusive, signed prints. Each print
        is autographed during a live or private signing session, making it a
        one-of-a-kind collector’s item. Because of the personalized and
        limited-edition nature of our products, we kindly ask that you review
        our refund policy below.
      </p>

      <h2>All Sales Are Final </h2>

      <p>
        All signed print sales made through Streamily are <strong>final</strong>
        . Each print is signed specifically for the buyer—often with custom
        inscriptions or personalization—and cannot be returned, refunded, or
        exchanged due to change of mind or buyer’s remorse.
      </p>

      <p>
        Streamily’s signed prints and video messages are personalized products
        that often require some time and effort from the artist to complete.
        Most orders cannot be fulfilled until a live event or private signing
        session has been scheduled. Artists on Streamily have the sole
        discretion to determine when and how they will sign your item. However,
        every effort is made by Streamily to have your item signed as soon as
        possible.
      </p>

      <h2>Refund Eligibility</h2>

      <p>
        In the rare event that your order <strong>cannot be fulfilled</strong>{" "}
        because talent is unable or unwilling to sign, we’ll refund your
        purchase or offer Streamily credits.
      </p>

      <p>
        <strong>Unsigned</strong> orders not fulfilled within 90 days of
        purchase are eligible for Streamily credits.
      </p>

      <p>
        To initiate a refund request under these conditions, please contact us
        at{" "}
        <Link href="mailto:support@streamily.com">support@streamily.com</Link>{" "}
        with your order number and relevant details.
      </p>

      <h2>Damaged or Incorrect Orders</h2>

      <p>
        If you receive a print that arrives <strong>damaged</strong> or is{" "}
        <strong>not the item you ordered</strong>, please notify us within 7
        days of delivery. After reviewing your request, we may offer one of the
        following resolutions at our discretion:
      </p>

      <ul>
        <li>
          <p>A replacement print (if available)</p>
        </li>
        <li>
          <p>A comparable signed print</p>
        </li>
        <li>
          <p>Store credit</p>
        </li>
        <li>
          <p>A full refund (in rare cases)</p>
        </li>
      </ul>

      <p>Please include:</p>
      <ul>
        <li>
          <p>Your order number</p>
        </li>
        <li>
          <p>Clear photos of the damaged print and packaging</p>
        </li>
        <li>
          <p>A brief description of the issue</p>
        </li>
      </ul>

      <p>
        Note: Minor variations in signature placement, ink color, or
        personalization style are expected and not considered defects.
      </p>

      <p>When returning an item please note:</p>
      <ul>
        <li>
          <p>
            Items must be in 100% original condition (no modifications,
            including but not limited to framing or mounting) and include all
            paperwork.
          </p>
        </li>
        <li>
          <p>
            Items must be returned safely and securely with the original
            receipt. We highly recommend insuring and tracking the item, as we
            cannot be held responsible for loss or damage.
          </p>
        </li>
      </ul>

      <h2>Authenticity Guarantee</h2>

      <p>
        All prints sold through Streamily are 100% authentic and signed by the
        celebrity during a verified signing session. Proof of authenticity may
        include:
      </p>

      <ul>
        <li>
          <p>A certificate of authenticity (when provided)</p>
        </li>
        <li>
          <p>Livestream footage or video documentation (when available)</p>
        </li>
      </ul>

      <p>We fully stand behind the authenticity of every signed print.</p>

      <h2>Shipping & Address Issues</h2>

      <p>
        Streamily is not responsible for delivery issues due to incorrect or
        incomplete shipping information provided at checkout. Please verify your
        address before completing your order.
      </p>

      <p>
        <strong>If your address changes after placing your order</strong>,
        please notify our customer support team at{" "}
        <Link href="mailto:support@streamily.com">support@streamily.com</Link>{" "}
        <strong>as soon as possible</strong> so we can attempt to update it
        before shipment.
      </p>

      <p>
        If an item is returned due to an incorrect address, additional shipping
        fees may apply for resending.
      </p>

      <p>
        For questions or refund requests, please contact us at{" "}
        <Link href="mailto:support@streamily.com">support@streamily.com</Link>.
      </p>

      <p>Thank you for being a part of the Streamily experience!</p>
    </ContentPage>
  );
}
